import { render, staticRenderFns } from "./FirmPage.vue?vue&type=template&id=48e459b4&scoped=true"
import script from "./FirmPage.vue?vue&type=script&lang=js"
export * from "./FirmPage.vue?vue&type=script&lang=js"
import style0 from "./FirmPage.vue?vue&type=style&index=0&id=48e459b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e459b4",
  null
  
)

export default component.exports